import { REACT_APP_STAGE } from "config";
import { Pesos } from "../constants/constants";

export const getCurrentTime = () => {
  return Math.floor(new Date().getTime() / 1000);
};

export const getOnlyNumerals = (text: string) => `${text.replace(/[^0-9]/g, "")}`;

export const prepend0ToContact = (contact: string) => {
  const mobileNumber = getOnlyNumerals(contact);

  return `0${mobileNumber}`;
};

export const parseJSONArrayString = (jsonArrayString: string) => {
  try {
    const returnData = JSON.parse(jsonArrayString);
    if (returnData.length > 0) {
      return returnData;
    }

    return [];
  } catch (e) {
    return [];
  }
};

export const isAppRunningInDev = (): boolean => {
  return String(REACT_APP_STAGE) === "staging";
};

export const parseJSONObjectString = (jsonObjectString: string) => {
  try {
    const returnData = JSON.parse(jsonObjectString);

    return returnData || {};
  } catch (e) {
    return {};
  }
};

export const isEmpty = (value: any) => {
  if (value === null || value === undefined) {
    return true;
  }
  if (Array.isArray(value)) {
    return value.length === 0;
  } else if (typeof value === "object") {
    return Object.keys(value).length === 0 && value.constructor === Object;
  } else if (typeof value === "string") {
    return value.trim().length === 0;
  } else if (typeof value === "number") {
    return value <= 0;
  } else if (!value) {
    return true;
  }

  return false;
};

export const parseGqlProducDeltaMeta = (jsonObjectString: string) => {
  try {
    const returnData = JSON.parse(jsonObjectString);

    return returnData || { category_id: null, sub_category_id: null, brand_id: null };
  } catch (e) {
    return { category_id: null, sub_category_id: null, brand_id: null };
  }
};

export const convertBooleanToNumber = (value: boolean) => {
  if (typeof value === "boolean") {
    return Number(value);
  }

  return value;
};

export const roundNumberToTwoDecimals = (value: number) => {
  let number = `${value}`;
  number = number.replace("/[,]/g", "");

  return Number(number).toFixed(2);
};

export const getPesosPrefixFixedToTwoDigits = (value: number, displayCurrency?: string) =>
  `${displayCurrency || Pesos}${roundNumberToTwoDecimals(value)}`;

export const maskString = (str: string) => {
  // Check if the input is a string
  if (typeof str !== "string") {
    return "";
  }

  // Check if the string length is less than 7
  if (str.length < 7) {
    return "";
  }

  // Extract first 3 and last 3 characters
  var firstThree = str.slice(0, 3);
  var lastThree = str.slice(-3);

  // Mask the middle characters
  var maskedMiddle = str.slice(3, -3).replace(/./g, "*");

  // Concatenate and return the masked string
  return firstThree + maskedMiddle + lastThree;
};

export const formatMobileNumber = (inputValue: string) => {
  let phoneNumber = inputValue || "";
  phoneNumber = `${phoneNumber.substring(0, 3)} ${phoneNumber.substring(3)}`;
  phoneNumber = `${phoneNumber.substring(0, 7)} ${phoneNumber.substring(7)}`.trim();

  return phoneNumber;
};

export const isValidMobileNumber = (inputValue: string) => {
  let regex = /^9\d*$/;
  return !!regex.test(inputValue.replace(/[^0-9]/g, "").substring(0, 10));
};

export const isUUID = (id: string | number): boolean => {
  const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
  return typeof id === "string" && uuidRegex.test(id);
};
